export const SIGN_IN_DRAWER = 'SIGN_IN_DRAWER';
export const REGIONAL_CTA_DRAWER = 'REGIONAL_CTA_DRAWER';
